import styled from "styled-components";

export const Wrapper = styled.nav`
  width: 100%;
  height: 100%;
  ul,
  ul li {
    margin: 0;
    padding: 0;
    display: flex;
    width: 100%;
    transition: all 0.3s ease-in-out;
  }
  ul {
    counter-reset: counter;
    li {
      flex-direction: column;
      align-items: center;
      position: relative;
      transition: all 0.3s ease-in-out;
      cursor: pointer;
      .circle-big {
        width: 40px;
        height: 40px;
        top: -7px;
        left: calc(50% - 21px);
        background-color: #f5f5f5;
        border-radius: 50%;
        position: absolute;
        z-index: 2;
      }
      .circle-active {
        opacity: 0;
        position: absolute;
        top: -1px;
      }
      .circle-completed {
        opacity: 0;
        position: absolute;
        top: -1px;
      }
      &.active {
        .circle-active {
          opacity: 1;
          z-index: 4;
        }
        .info-box {
          background: ${({ theme }) => theme.colors.red};
          &:before {
            content: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="11" height="8" viewBox="0 0 11 8" fill="none"><path d="M5.5 0L10.6962 7.5H0.303848L5.5 0Z" fill="%23BE1622"/></svg>');
          }
        }
      }
      &.completed {
        .circle-completed {
          opacity: 1;
          z-index: 4;
        }
        .info-box {
          background: ${({ theme }) => theme.colors.red};
          &:before {
            content: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="11" height="8" viewBox="0 0 11 8" fill="none"><path d="M5.5 0L10.6962 7.5H0.303848L5.5 0Z" fill="%23BE1622"/></svg>');
          }
        }
      }
      &:before {
        counter-increment: counter;
        content: counter(counter);
        display: flex;
        justify-content: center;
        align-items: center;
        width: 27px;
        height: 27px;
        text-align: center;
        border-radius: 50%;
        background: #d9d9d9;
        color: ${({ theme }) => theme.colors.white};
        font-family: JetBrains Mono;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        transition: all 0.3s ease-in-out;
        z-index: 3;
      }
      & ~ li::after {
        content: "";
        position: absolute;
        width: 100%;
        right: 50%;
        height: 11px;
        top: calc(0.75em - 5px);
        z-index: 1;
        transition: all 0.3s ease-in-out;
      }
      .info-box {
        display: flex;
        justify-content: center;
        align-items: center;
        background: #d9d9d9;
        padding: 6px;
        color: ${({ theme }) => theme.colors.white};
        font-family: JetBrains Mono;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        font-size: 12px;
        text-align: center;
        @media (min-width: 768px) {
          padding: 10px;
          font-size: 16px;
        }
        margin-top: 25px;
        position: relative;
        &:before {
          position: absolute;
          top: -20px;
          content: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="11" height="8" viewBox="0 0 11 8" fill="none"><path d="M5.5 0L10.6962 7.5H0.303848L5.5 0Z" fill="%23D9D9D9"/></svg>');
        }
      }
    }
  }
  ul .active ~ li::before,
  ul .active ~ li::after {
    background: #d9d9d9;
  }

  ul li.completed::before {
    /*  counterber and circle  */
    background: ${({ theme }) => theme.colors.red};
    color: white;
  }

  ul li.completed + li::after {
    /*  line after circle  */
    background: ${({ theme }) => theme.colors.red};
  }
  ul li.completed::after {
    /*  line before circle  */
    background: ${({ theme }) => theme.colors.red};
  }
`;
